/* Component Dependencies */
var $ = require('jquery');
require('jquery-ui');

var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var Popup = require('libs/popup');

var destinationSearchTemplate = require('templates/destinationSearch.hbs');
var SpecialRatesHandler = require('search_libs/special-rates-handler');
var AutoCompleteHandler = require('libs/auto-complete-handler');
var AutoCompleteHandlerV2 = require('libs/auto-complete-handler-v2');
var SearchTabHandler = require('search_libs/search-tab-handler');
var ScrollBarHandler = require('libs/scrollbar');
var ResponsiveUtils = require('utils/responsiveUtils');

var GoogleApi = require('libs/google-api');
var GoogleAutocompleteHandler = require('search_libs/autocompleteHandler');
var AutocompleteFormFieldMapper = require('search_libs/autocompleteHandler/autocompleteFormFieldMapper');
var AutocompleteFormMapping = require('search_libs/autocompleteHandler/autocompleteFormMapping');
var recentSearchService = require('libs/autocomplete/recentSearchService');
var validateMarshaHandler = require('libs/validateMarshaHandler');


PubSub.register(AriesComponent.extend({
  type: 'destinationSearch',
  isHeaderSearchForm: false,
	 template: {
    'destinationSearch': destinationSearchTemplate
},
  subscribe: {
	  'CLEARALL_DESTINATION_SEARCH_FILTERS': 'clearAll'
  },
  options: {
    'scrollBarTarget': '.m-flex-frame-wrapper'
  },
  unBindEvents: function($) {
    $('[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  events: {
    'click .l-hsearch-labels .single-search,.l-hsearch-labels .js-moreoptions-expander-click': 'expandSearchBar',
    'focusin .l-hsearch-labels .single-search,.l-hsearch-labels .js-moreoptions-expander-click': 'expandSearchBar',
    'keyup .js-auto-complete-input-v2': 'hideRateClusterField',
	'click .js-region-toggle':'toggleRegion',
	'click .js-state-toggle':'toggleState',
	'click .js-clear-trigger':'clearToggle',
	'click .js-view-less':'handleViewAll',
	'click .js-view-all':'handleViewLess',
  'click #close-icon':'clearBreadCrumbs',
  'blur .js-input-value': 'hasSearchLocation',
  'click .js-country-details .js-region-toggle': 'hasSelectedRegion',
  'click .js-clear-region': 'hasRemovedRegion'
  },
  bindEvents: function() {
    var _self = this;
	_self.displayCount();

    _self.isAutoCompleteHandlerInitiated = false;
    _self.validateMarshaHandler = new validateMarshaHandler();
    //adding custom class when opening force sell overlay through unsuccesful popup
    _self.$el.closest('.t-modal-smallMed').addClass('m-modal t-modal-smallMed force-sell-overlay-form');

    this.idPrefix = this.$el.data("id-prefix");
    this.autocompleteInputEl = this.$el.find('#'+this.idPrefix+'_search-location')[0];
    this.enableGooglePlaceAutoSuggestion = this.$el.data('enable-google-places-api');
    this.enableCustomAutoSuggest = this.$el.data('custom-auto-suggest');

    var searchFormFieldWrap = _self.$el.find('.m-field-wrap');
    var searchFormHeader = _self.$el.find('.m-field-wrap').prev();

    //micore lib jQuery tab fix
    if (!this.enableGooglePlaceAutoSuggestion) {
      this.$el.parent().find(".search-saved-hotels-tabs, .single-search-tabs").tabs().tabs('destroy');
    }
    this.$el.find('.special-rates-section .ui-tabs-selected').removeClass('ui-tabs-selected');

    // open the sell options dropdown by default if datepicker is not there
    if(!this.$el.find('.js-datepick-container').length) {
      this.$el.find('.js-special-rates-header').click();
    }

    this.initHotelSellOptions();
    if(this.$el.find('.l-hsearch-loc').length) {
      this.initAutocomplete();
    }  
    
    this.initSearchTabHandler();
    if (typeof hdVars !== 'undefined' && this.$el.data('roomkeyflag')) {
      var roomKeyHandler = new RoomKeyHandler({
          $el: this.$el,
          $parent: this
        });
      roomKeyHandler.init();
    }
    /**Ends**/

    
    // Saving the current active tab.
    _self.activeTab = _self.$el.find('.ui-tabs-active a');
    var activeTab = this.$el.find('.search-tab-list .associate-active-tab');
    if (activeTab.length) {
      _self.$el.addClass('default-tab-change');
      activeTab.find('a').click();
    }

    // Making destination field non editable after submit
    var fieldInputValue = $('#destinationSearchLocation .m-field-control input').val();
    if(fieldInputValue) {
	$('#close-icon').addClass('js-close-icon');
    	$('.js-country-details').addClass('l-display-none');
    }

    // Hide Search location field and retain breadcrubs after submit
    var regionBreadcrumbValue = $('.js-region-breadcrumb input').val();
    if(regionBreadcrumbValue) {
    	$('#destinationSearchLocation .m-field-control').addClass('l-search-field');
    	$('.js-region-breadcrumb').removeClass('l-display-none');
    	var subregionBreadcrumbValue = $('.js-subregion-breadcrumb input').val();
	var id = $('.l-icon-region-search').data('region');
    	if(subregionBreadcrumbValue){
    		$('.js-subregion-breadcrumb').removeClass('l-display-none');
    		$('.m-sorted-state-list').addClass('is-hidden');
    		$('.js-country-details').addClass('l-display-none');
    		$('.l-view-region-all').addClass('is-hidden');
    	} else {
    		_self.toggleRegionHandler(id);
	}
	var breadCrumbValue = $('.js-'+id+' .t-region').text();
	$('#region-breadcrumb').val(breadCrumbValue);
    }
   // Getting search location 
  _self.hasSearchLocation({target: _self.$el.find('.js-input-value')[0]});  
  },
  displayCount: function(){
    var _self = this;
    $(".m-state-list").each(function(){
	var count = 0;
	var id = "js-" + $(this).attr('id');
    $(this).find("[data-count]" )
      .each(function(){
        count += $( this ).data().count;
      })
      $('.'+id).find('.js-region-count').text( "("+count+")" );
  });
  },

  clearAll: function(data){
	var _self = this;
	if(data == true){
	    _self.clearBreadCrumbs();
	}
  },

  clearBreadCrumbs: function(){
	$('.js-input-auto-complete').removeClass('l-search-field');
	$('.js-country-details').removeClass('l-display-none');
	$('.m-sorted-state-list').addClass('is-hidden');
	$('.m-state-list').addClass('is-hidden');
	$('.l-view-region-all').addClass('is-hidden');
	$('.l-view-region-less').addClass('is-hidden');
    $('.js-breadcrumb').addClass('l-display-none');
	$('#close-icon').removeClass('js-close-icon');
	$('.js-region').val("");
	$('.js-region-label').val("");
	$('.js-subregion').val("");
	$('.js-subregion-label').val("");
  },

  handleViewAll: function(e){
    var region = $(e.currentTarget).data("region");
		$('#'+region).addClass('is-hidden');
		$('#'+region+'-hide').addClass('is-hidden');
		$('#'+region+'-view').removeClass('is-hidden');
  },
  handleViewLess: function(e){
    var region = $(e.currentTarget).data("region");
		$('#'+region).removeClass('is-hidden');
		$('#'+region+'-view').addClass('is-hidden');
		$('#'+region+'-hide').removeClass('is-hidden');
  },
  toggleRegion: function(e){
    var id = $(e.currentTarget).data('region');
    var _self = this;
    _self.toggleRegionHandler(id);
		
  },

  toggleRegionHandler: function(id){
	var breadCrumbValue = $('.js-'+id+' .t-region').text();
	$('#region-breadcrumb').val(breadCrumbValue);
	$('.js-region-breadcrumb span').data("region",id);
	$('.js-input-auto-complete').addClass('l-search-field');
	$('.js-region-breadcrumb').removeClass('l-display-none');
	$('.js-country-details').addClass('l-display-none');
	$('#'+id+'-sorted-states').removeClass('is-hidden');
	$('#'+id+'-view').removeClass('is-hidden');
	$('.js-region').val(id);
	var region = $('#region-breadcrumb').val().replace(/[()0-9]/g, "");
	$('.js-region-label').val(region);
	$('#destinationSearchLocation .m-field-control input').val('');
  },

  toggleState: function(e){
   var region = $(e.currentTarget).parent('ul').data("region");
		var id = $(e.currentTarget).data("region");
		var breadCrumbValue = $('.js-'+region+'-'+id+' span').text();
		$('#subregion-breadcrumb').val(breadCrumbValue);
		$('.js-subregion-breadcrumb span').data("region",region);
		$('.js-subregion-breadcrumb').removeClass('l-display-none');
		$('#'+region+'-sorted-states').addClass('is-hidden');
		$('#'+region).addClass('is-hidden');
		$('#'+region+'-view').addClass('is-hidden');
		$('#'+region+'-hide').addClass('is-hidden');
		$('.js-subregion').val(id);
		$('.js-subregion-label').val(breadCrumbValue);
  },
  clearToggle: function(e){
    var correspondingInput = $(e.currentTarget).prev('input')[0].id;
		$('#correspondingInput').val("");
		$('.js-'+correspondingInput).addClass('l-display-none');
		if(correspondingInput == "region-breadcrumb") {
			var id = $('.js-'+correspondingInput+' span').data("region");
			$('.js-subregion-breadcrumb').addClass('l-display-none');
			$('.js-input-auto-complete').removeClass('l-search-field');
			$('.js-country-details').removeClass('l-display-none');
			$('#'+id+'-sorted-states').addClass('is-hidden');
			$('#'+id+'-view').addClass('is-hidden');
			$('#'+id+'-hide').addClass('is-hidden');
			$('#'+id).addClass('is-hidden');
			$('.js-region').val("");
			$('.js-region-label').val("");
			$('.js-subregion').val("");
			$('.js-subregion-label').val("");
		} else if(correspondingInput == "subregion-breadcrumb") {
			var id = $('.js-'+correspondingInput+' span').data("region");
			$('#'+id+'-sorted-states').removeClass('is-hidden');
			$('#'+id+'-view').removeClass('is-hidden');
			$('.js-subregion').val("");
			$('.js-subregion-label').val("");
		}
  },
  /**
  * This function is used to expand Search Form on Homepage in Desktop
  */
  expandSearchBar: function() {
    var _self = this,
        scrollTop = 0;
        this.$el.addClass('transition-complete');
        this.$el.addClass('is-opened');
        this.$el.find('.t-more-search-options').removeClass('is-hidden').slideDown(400);
                $('html,body').animate({scrollTop: _self.$el.offset().top - 200});
  },
  /**
  * This function is used to animate scrolltop
  */
  scrollToView: function (element, offset) {
      element.animate({
      scrollTop: offset
    })
  },
  /**
  * This function is used to initialize search tab handler library for Search Forms
  */
  initSearchTabHandler: function() {
    if (this.$el.find('.search-tab-list li').length && !this.$el.hasClass('hws-search-form')) {
      var searchTabHandler = new SearchTabHandler({
        $el: this.$el,
        currentTemplate: this.currentTemplate,
        parent: this
      });
      searchTabHandler.init();
    }
  },
  /**
  * This function is used to initialize autocomplete handler library for Search Forms
  */
  initAutoCompleteHandler: function() {
    if(this.isAutoCompleteHandlerInitiated){
      return true;
    }
    this.isAutoCompleteHandlerInitiated = true;
    /*Hotel search auto suggest handler*/
    if (this.$el.find('.js-input-auto-complete.js-location').length) {
      this.autoCompleteHandler = AutoCompleteHandler.create({
        $el: this.$el.find('.js-input-auto-complete.js-location'),
        $parent: this,
        onListItemSelect: _.bind(this.handleFormAction, this),
        onClear: _.bind(this.setDefaultFormAction, this),
        onListClose: function() {
          if(this.$input.val()) {
            this.listItemSelect();  
          }
        }    
      
      });
      this.autoCompleteHandler.init();
    }
    /*Cluster Code auto suggest handler*/
    if (this.$el.find('.js-cluster-autocomplete').length){
       this.autoCompleteClusterCodeHandler = AutoCompleteHandlerV2.create({
        $el: this.$el.find('.js-cluster-autocomplete'),
        $parent: this,
        onListItemSelect: _.bind(this.setClusterValue, this),
        clusterSearchHandler : true
      });
    this.autoCompleteClusterCodeHandler.init();
    }
  },
  /**
  * This function is used to initialize autocomplete handler library for Search Forms
  */
  initAutoCompleteHandlerV2: function() {
    /*Hotel search auto suggest handler*/
    if (this.$el.find('.js-input-auto-complete.js-location').length) {
      this.autoCompleteHandlerV2 = AutoCompleteHandlerV2.create({
        $el: this.$el.find('.js-input-auto-complete.js-location'),
        $parent: this,
        onListItemSelect: _.bind(this.handleFormAction, this),
        onClear: _.bind(this.setDefaultFormAction, this),
        sessionId: this.getSessionToken(),
        enableUserLocation: this.$el.data("enable-user-location"),
        onListClose: function() {
          if(this.$input.val()) {
            this.listItemSelect();  
          }
        }   
      });
      this.autoCompleteHandlerV2.init();
    }
    /*Cluster Code auto suggest handler*/
    if (this.$el.find('.js-cluster-autocomplete').length){
       this.autoCompleteClusterCodeHandler = AutoCompleteHandlerV2.create({
        $el: this.$el.find('.js-cluster-autocomplete'),
        $parent: this,
        onListItemSelect: _.bind(this.setClusterValue, this),
        clusterSearchHandler : true
      });
    this.autoCompleteClusterCodeHandler.init();
    }
  },
  /**
  * This function is use to initialize scroller plugin on target elements
  */
  initScroller: function() {
    var _self = this;
      this.scrollbar = ScrollBarHandler.create({
        $el: this.$el,
        $scrollBarTarget: this.$el.find(_self.options.scrollBarTarget).not('.custom-wrapper')
      });
      this.scrollbar.init();
  },
  /**
  * This function is use to toggle form action based on what sort of autosuggest input selected
  */
  handleFormAction: function(autocompleteContext) {
    var form = this.$el.find('form');
    var suggestionEndpointMapper = form.data('suggestion-endpoint-mapping');
    var suggestionType = autocompleteContext ? autocompleteContext.autoSuggestOmni : this.$el.find('.js-autosuggest-item-type').val();

    this.setDefaultFormAction();

    var formAction;

    var groupsFlowFlag = form.data('is-group-search-applicable');
    if(this.setGroupsFlow && groupsFlowFlag) {
      formAction = form.data('group-search-endpoint');
      form.attr('action', formAction);
    }else if (suggestionEndpointMapper && suggestionEndpointMapper[suggestionType]) {
      formAction = suggestionEndpointMapper[suggestionType];
      this.$el.find('input[name="isSearch"]').val(false);
      form.attr('action', formAction);
    }
  },
  /**
  * This function is use to set default form action for Search Forms
  */
  setDefaultFormAction: function() {
    var form = this.$el.find('form');
    var defaultEndpoint = form.data('default-endpoint');
    if (defaultEndpoint) {
      form.attr('action', defaultEndpoint);
    }
  },
  setClusterValue: function(autocompleteContext){
    var clusterCodeVal = autocompleteContext.clusterCode;
    this.$el.find('#hiddenClusterCode').val(clusterCodeVal);
  },
    /**
     * Conditionally initialize autocomplete handler for Marriott or Google Places API (R3 Change)
     */
      initAutocomplete: function() {
      var _self = this;
      var googleMapOptions = _self.$el.find(".search-google-map").data('options');

      var geoLocationCN = !_self.$el.data("suppress-google-api");
      var $listContainerEl = _self.$el.find('.l-hsearch-loc');
      var autocompleteSupportedTypesString = _self.$el.data("autocomplete-supported-types");
      var autocompleteSupportedTypes = !autocompleteSupportedTypesString?'':autocompleteSupportedTypesString.split(',');
      
      if(geoLocationCN !== true || this.enableCustomAutoSuggest){
        if(this.enableCustomAutoSuggest){
          $(this.autocompleteInputEl).addClass('js-auto-complete-input-v2');
           _self.initAutoCompleteHandlerV2();
        }else{
          if (!this.enableGooglePlaceAutoSuggestion) { 
            $(this.autocompleteInputEl).addClass('js-auto-complete-input');
          }
          else{
            // Google api initialized with google api url path and language parameter using google-api core lib 
            GoogleApi.create({
              apiUrl: googleMapOptions.api,
              language: googleMapOptions.language,
              success: function(apiWrapper) {
                // Google apiWrapper and autocomplete options are passed to autocomplete handler
                new GoogleAutocompleteHandler(_self, apiWrapper, {
                  disableLocationSearch:_self.isAssociateView,
                  listContainerEl: $listContainerEl,
                  autocompleteSupportedTypes: autocompleteSupportedTypes
                });
              }
            }).init();
            _self.updateRecentSearchData();
          }
          _self.initAutoCompleteHandler();
        }
      }else{
        $(_self.autocompleteInputEl).on('change',function(){
          _self.$el.find('.js-search-radius,.search-latitude,.search-longitude').val('');
        });
      }
      

      if(_self.$el.parent().find(".tile-adv-search-associate-form").length){
        _self.initAutoCompleteHandler();
      }
    },

    /**
     * Update recent search data in locastorage if available in search form inputs
     */
    updateRecentSearchData: function() {
      var $form = this.$el.find('form');

      //Update recent search data only if a successfull search
      if (!$form.hasClass("js-recent-search-inputs")) {return;}

      var autocompleteFormFieldMapper = new AutocompleteFormFieldMapper($form[0], AutocompleteFormMapping.get($form.attr('id'))),
        data = autocompleteFormFieldMapper.getFormData(),
        hasEmptyVal = false,
        fields = ['placeId', 'mainText', 'secondaryText', 'stateProvince', 'country'],
        recentSearch = recentSearchService.get('miRecentSearchPlaces', 3);

      fields.forEach(function(item) {
        if (!data[item]) {
          hasEmptyVal = true;
        }
      });

      if (hasEmptyVal === false) {
        recentSearch.set(data, 'placeId');
      }
    },
    initHotelSellOptions:function(){
      if(this.$el.find('.single-search-type').val()==="true"){
        this.$el.find('.js-autosuggest-item-type').val('property');
        this.$el.find('li.city-search-options').addClass('is-hidden');
        this.$el.find('li.hotel-search-options').removeClass('is-hidden');
        this.initHotelSortOrder();
        this.handleFormAction();
      }
      else{
        if(this.$el.find('.js-autosuggest-item-type').val()!=="property"){
          this.$el.find('.js-autosuggest-item-type').val('');
        }
        this.setDefaultFormAction();
        this.$el.find('li.hotel-search-options').addClass('is-hidden');
        this.$el.find('li.city-search-options').removeClass('is-hidden');
      }
    },
    initHotelSortOrder:function(){
      if(this.$el.find('.l-adv-search-associate').data('hotel')){
          var options=this.$el.find('.l-adv-search-associate').data('options');
          var hoteloptions=this.$el.find('.l-adv-search-associate').data('hotel');
          options.suggestionSortOrder=hoteloptions;
          this.$el.find('.l-adv-search-associate').attr('data-options', JSON.stringify(options));
      }
    },
    isActiveSpecialRatesHandler: function() {
      if (this.specialRatesHandler) {
        return this.specialRatesHandler.takeoverScreen.isActive;
      }
      return false;
    },
    /*
    * hide cluster code element for cloned rate cluster container
    */
    hideRateClusterField: function(event){
      var _self=this;
      if((_self.$el.find('.js-validate-search-form').find('[name="isAssociateFlow"]').val()==='true' && _self.$el.parents().find('.tile-error-messages-searchform').find('.m-message-box-error').length) || _self.$el.find('[name="isAssociateFlow"]').val()==='true'){
        if(!_self.$el.find('.js-validate-search-form').find('.code-container').parent('div').hasClass('.js-code-section-replica')){
          _self.$el.find('.js-validate-search-form').find('.code-container').eq(1).find('.js-auto-complete-input-v2').remove();
          _self.$el.find('.special-rates-section.sell-options-section').find('.code-container').eq(1).find('.js-auto-complete-input-v2').remove();
          _self.$el.find('.special-rates-section.sell-options-section').find('.code-container').eq(1).remove();
        }
      }
    },
    hasSearchLocation: function(evt) {
      var value = evt.target.value;
      this.pubsub.publish('HOTEL_OPTIONAL_FILTERS', [(value && value.length && true)]);
    },
    hasSelectedRegion: function() {
      this.pubsub.publish('HOTEL_SELECTED_REGION');
    },
    hasRemovedRegion: function() {
      this.pubsub.publish('HOTEL_REMOVED_REGION');
    }
}));
